<button
  type="button"
  class="home-action-item"
  [attr.aria-label]="'Ir para ' + item.label"
  (click)="onNavigate()">
  <span class="home-action-item__icon" aria-hidden="true">
    <b3-icon [name]="item.icon" size="lg" tone="neutral"></b3-icon>
  </span>
  <span class="home-action-item__label">{{ item.label }}</span>
  <span class="home-action-item__arrow" aria-hidden="true">
    <b3-icon name="arrow_forward" size="md" tone="neutral"></b3-icon>
  </span>
</button>
